<template>
  <div class="calendar" :class="{white}">
    <div class="calendar-header">
      <div class="controls">
        <button class="control-btn" @click="prev" v-if="!mini">&#x276E;</button>
        <div class="title" v-html="getTitle()"></div>
        <button class="control-btn" @click="next" v-if="!mini">&#x276F;</button>
      </div>
      <div class="right-controls">
        <button class="drop" :class="{active: !mini}" @click="mini = !mini">
          <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 2.75H20V1.25H7V2.75ZM7 8.75H20V7.25H7V8.75ZM7 14.75H20V13.25H7V14.75ZM2.25 2C2.25 2.13807 2.13807 2.25 2 2.25V3.75C2.9665 3.75 3.75 2.9665 3.75 2H2.25ZM2 2.25C1.86193 2.25 1.75 2.13807 1.75 2H0.25C0.25 2.9665 1.0335 3.75 2 3.75V2.25ZM1.75 2C1.75 1.86193 1.86193 1.75 2 1.75V0.25C1.0335 0.25 0.25 1.0335 0.25 2H1.75ZM2 1.75C2.13807 1.75 2.25 1.86193 2.25 2H3.75C3.75 1.0335 2.9665 0.25 2 0.25V1.75ZM2.25 8C2.25 8.13807 2.13807 8.25 2 8.25V9.75C2.9665 9.75 3.75 8.9665 3.75 8H2.25ZM2 8.25C1.86193 8.25 1.75 8.13807 1.75 8H0.25C0.25 8.9665 1.0335 9.75 2 9.75V8.25ZM1.75 8C1.75 7.86193 1.86193 7.75 2 7.75V6.25C1.0335 6.25 0.25 7.0335 0.25 8H1.75ZM2 7.75C2.13807 7.75 2.25 7.86193 2.25 8H3.75C3.75 7.0335 2.9665 6.25 2 6.25V7.75ZM2.25 14C2.25 14.1381 2.13807 14.25 2 14.25V15.75C2.9665 15.75 3.75 14.9665 3.75 14H2.25ZM2 14.25C1.86193 14.25 1.75 14.1381 1.75 14H0.25C0.25 14.9665 1.0335 15.75 2 15.75V14.25ZM1.75 14C1.75 13.8619 1.86193 13.75 2 13.75V12.25C1.0335 12.25 0.25 13.0335 0.25 14H1.75ZM2 13.75C2.13807 13.75 2.25 13.8619 2.25 14H3.75C3.75 13.0335 2.9665 12.25 2 12.25V13.75Z"
                fill="#B9765B"/>
          </svg>
        </button>
        <button class="drop" @click="$emit('addEvent')" v-if="!hideAdd">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 5V15M5 10H15" stroke="#B9765B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="weekdays">
      <div v-for="day in days" :key="'weekdays'+day">{{ day }}</div>
    </div>
    <div class="dates">
      <div v-for="blank in renderOffset" :key="blank"></div>
      <div
          v-for="date in daysRender()"
          :key="date.date+'day'"
          class="date"
      >
        <div
            :class="{today: date.today, selected: isSelected(date.date), b: isBold(date.date)}"
            class="day"
            @click="$emit('input', date.date)"
        >
          <div>
            {{ date.string }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "miniCalendar",
  props: {
    value: {
      dafault: () => new Date()
    },
    white: {
      type: Boolean,
      default: false
    },
    hideAdd: {
      type: Boolean,
      default: false
    },
    admin: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.admin) {
      this.getDates()
    }
  },
  data: () => ({
    today: moment(),
    dateContext: moment().startOf('month'),
    selDate: moment(),
    dates: [],
    days: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    mini: true
  }),
  methods: {
    getDates() {
      this.$api.admin.rent.dates(this.$moment(this.value).format('YYYY-MM'))
          .then((data) => {
            this.dates = data.map((item) => {
              return this.$moment(item).startOf('day')
            })
          })
    },
    isBold(date) {
      if (this.admin) {
        return this.dates.some((item) => {
          return this.$moment(date).startOf('day').isSame(item, 'd')
        })
      } else {
        return false
      }
    },
    next() {
      this.dateContext = this.$moment(this.dateContext).add(1, 'month').startOf('month');
    },
    prev() {
      this.dateContext = this.$moment(this.dateContext).subtract(1, 'month').startOf('month');
    },
    daysRender() {
      let num = this.dateContext.daysInMonth()
      let cntx = this.dateContext;
      let month = []
      if (!this.mini) {
        for (let i = 1; i <= num; i++) {
          month.push({
            date: this.$moment(cntx).set('date', i).startOf('day'),
            string: i,
            today: this.$moment(cntx).set('date', i).startOf('day').isSame(this.$moment(), 'd'),
          })
        }
      } else {
        let start_week = this.$moment(this.value).startOf('week')
        let end_week = this.$moment(this.value).endOf('week')
        let day = start_week
        while (day <= end_week) {
          if (day.format('M') == this.$moment(this.value).format('M'))
            month.push({
              date: day.clone().startOf('day'),
              string: day.clone().format('D'),
              today: day.clone().startOf('day').isSame(this.$moment(), 'd'),
            })
          day = day.clone().add(1, 'd');
        }
      }
      return month
    },
    getTitle() {
      return `<b>${this.dateContext.format('MMMM')}</b> ${this.dateContext.format('YYYY')}`
    },
    isSelected(date) {
      return this.$moment(date).startOf('day').isSame(this.$moment(this.value), 'd')
    }
  },
  computed: {
    currentDate() {
      return this.dateContext.get('date')
    },
    renderOffset() {
      if (!this.mini) return this.$moment(this.dateContext).subtract((this.currentDate - 1), 'days').weekday()
      else {
        if (this.$moment(this.value).unix() < this.$moment(this.dateContext).date(1).endOf('week').unix())
          return this.$moment(this.dateContext).subtract((this.currentDate - 1), 'days').weekday()
        else return []
      }
    },
  },
  watch: {
    mini() {
      this.dateContext = this.$moment(this.value)
    },
    value(n, o) {
      let nw = this.$moment(n).format('YYYY-MM')
      let od = this.$moment(o).format('YYYY-MM')
      console.log(nw, od, nw != od)
      if (nw != od && this.admin) {
        this.getDates()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.calendar {
  width: 100%;
  min-width: 250px;
  background-color: #FAFAFA;
  padding: 15px;
  font-family: Open Sans;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;

  &.white {
    background-color: unset !important;
  }

}

.calendar-header {
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;

  button {
    background-color: unset;
    border: unset;
  }

  & .controls {
    display: flex;
    align-items: center;

    &.title {
      font-size: 20px;
      line-height: 28px;
      color: #383838;
    }

    & b {
      font-weight: 600;
    }
  }

  .control-btn {
    color: #DBBFA7;
    margin: 0 5px;
  }

  & .right-controls {
    display: flex;

    & button {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.active {
        background: #B9765B;
        border-radius: 5px;

        & > svg > path {
          fill: white;
        }
      }
    }
  }

}

.weekdays {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-items: stretch;
  margin-bottom: 5px;

  & > div {
    width: 100%;
    height: 20px;
    min-width: 30px;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #808080;
  }

}

.dates {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);

  & .date {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .day {
    cursor: pointer;
    width: 30px;
    height: 30px;
    text-align: center;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #383838;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;

    &.b {
      font-weight: bold;
    }

    &.today {
      border: 1px solid #B9765B;
    }

    &.selected {
      font-weight: normal;
      background-color: #B9765B;
      color: white;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }

    &.selected:hover {
      background-color: rgba(185, 118, 91, 0.8);
    }
  }
}

</style>
